import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NewResidentNotificationDialogComponent } from './notifications/new-resident-notification-dialog/new-resident-notification-dialog.component';
import {ChappsCommonAngularLibraryModule} from "@npm.chapps.com/chapps.common.angular.library";
import {TranslateModule} from "@ngx-translate/core";
import {NotificationsService} from "./notifications/notifications.service";
import {StructureTreeModule} from '../buildings/structure/structure-tree/structure-tree.module';



@NgModule({
  declarations: [
    NewResidentNotificationDialogComponent
  ],
    imports: [
        CommonModule,
        ChappsCommonAngularLibraryModule,
        TranslateModule,
        StructureTreeModule,
    ],
  exports: [
  ],
  providers: [
      NotificationsService
  ]
})
export class ResidentsModule { }
